import React from 'react'
import PropTypes from 'prop-types'

export const Apollo = ({ height, width, ...otherProps }) => (
  <svg
    role="img"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 211.31 237.31"
    {...otherProps}
  >
    <g transform="matrix(1 0 0 -1 413.8135 118.7803)">
      <polygon
        fill="rgb(51,51,51)"
        points="-284.735,51.4 -309.046,51.4 -344.147,-39.697 -322.157,-39.697 -316.421,-24.266     -283.255,-24.266 -289.259,-7.191 -311.095,-7.191 -296.89,32.006 -271.622,-39.697 -249.634,-39.697   "
      />

      <path
        fill="rgb(51,51,51)"
        d="M-209.558-67.345c-1.688,0-3.178-0.836-4.088-2.118c0,0-4.375-4.991-6.734-7.353     c-9.979-9.979-21.598-17.812-34.533-23.284c-13.387-5.663-27.611-8.534-42.281-8.534c-14.672,0-28.896,2.871-42.281,8.534     c-12.936,5.472-24.555,13.305-34.533,23.284c-9.98,9.981-17.814,21.599-23.285,34.534c-5.661,13.387-8.533,27.613-8.533,42.282     s2.872,28.895,8.533,42.282c5.471,12.935,13.305,24.553,23.285,34.532c9.979,9.98,21.598,17.813,34.533,23.285     c13.385,5.663,27.609,8.534,42.281,8.534c14.67,0,28.895-2.871,42.281-8.534c9.422-3.985,18.141-9.23,26.041-15.639     c-0.422-1.243-0.658-2.576-0.658-3.963c0-6.769,5.488-12.257,12.256-12.257c6.77,0,12.258,5.488,12.258,12.257     c0,6.77-5.488,12.257-12.258,12.257c-1.68,0-3.283-0.339-4.742-0.953c-20.467,16.782-46.645,26.858-75.178,26.858     c-65.535,0-118.661-53.125-118.661-118.66s53.126-118.661,118.661-118.661c36.658,0,69.42,16.636,91.184,42.758     c0.906,0.907,1.469,2.16,1.469,3.543C-204.542-69.588-206.786-67.345-209.558-67.345z"
      />
    </g>
  </svg>
)

Apollo.defaultProps = {
  height: '1.5rem',
  width: '1.5rem'
}

Apollo.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string
}
